/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchDevelopmentStageResponseDto } from '../../models/search-development-stage-response-dto';

export interface DevelopmentStageControllerSearchByParentV1$Params {

/**
 * 아동 ID
 */
  childId?: string;

/**
 * 월령(개월)
 */
  monthAge?: number;
}

export function developmentStageControllerSearchByParentV1(http: HttpClient, rootUrl: string, params?: DevelopmentStageControllerSearchByParentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchDevelopmentStageResponseDto>> {
  const rb = new RequestBuilder(rootUrl, developmentStageControllerSearchByParentV1.PATH, 'get');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('monthAge', params.monthAge, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchDevelopmentStageResponseDto>;
    })
  );
}

developmentStageControllerSearchByParentV1.PATH = '/api/v1/development-stage/search-by-parent';
